<template>
  <div>
    <span v-if="product.needProductPrice">
      {{ $t('product.needProductPrice') }}
    </span>
    <span v-else-if="product.needProductStock">
      {{ $t('product.needProductStock') }}
    </span>
    <span v-else-if="statusFilter(product.updateApproveStatus)">
      {{ statusFilter(product.updateApproveStatus) }}
    </span>
    <div
      v-else-if="!hasImage && !isOnsale"
    >
      Ürünün görseli eksik veya hatalıdır.
      Ürün görselini yüklediğinizde kontrol süreci başlayacaktır.
    </div>
    <span v-else-if="!product.approved">
      {{ $t('product.waitingForContent') }}
    </span>
  </div>
</template>
<script>
import Index from './Index';

export default {
  name: 'IndexNotOnSale',
  extends: Index,
};
</script>
